import React, { useState } from 'react';
import { Copy, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { duplicatesFormazioneApi } from '../lib/api';

// Elimina i doppioni formazione (stessa persona + stesso corso + stessa data), con backup.
const DuplicatesCleanupButton = ({ onDone }) => {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const { data: p } = await duplicatesFormazioneApi.preview();
      if (!p.totale) { toast.success('Nessun doppione trovato'); return; }
      if (!window.confirm(`Trovati ${p.totale} corsi doppi (stessa persona, stesso corso, stessa data).\n\nVerrà tenuta 1 sola copia per ciascuno, le altre saranno eliminate (backup automatico). Procedere?`)) return;
      const { data } = await duplicatesFormazioneApi.apply();
      toast.success(`${data.deleted} doppioni eliminati`);
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore rimozione doppioni');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={run}
      disabled={busy}
      data-testid="duplicates-cleanup-btn"
      className="inline-flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-semibold bg-white border border-amber-200 text-amber-800 hover:bg-amber-50 disabled:opacity-60"
    >
      {busy ? <Loader2 size={13} className="animate-spin" /> : <Copy size={13} />} Rimuovi doppioni
    </button>
  );
};

export default DuplicatesCleanupButton;
